import React from "react";
import Header from "../Header/Header.tsx";
import { Outlet } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar.jsx";
import { SidebarProvider, useSidebar } from "../../contexts/SidebarContext.tsx";
import { LoadingProvider, useLoading } from "../../contexts/LoadingContext.tsx";
import { PageLoadingProvider } from "../../contexts/PageLoadingContext.tsx";
import { ContentLoadingProvider } from "../../contexts/ContentLoadingContext.tsx";
import PageLoader from "../Loader/PageLoader.tsx";
import NavigationWrapper from "./NavigationWrapper.tsx";
const MainLayoutContent = () => {
    const { isSidebarOpen, isCollapsed, closeSidebar } = useSidebar();
    const { isLoading, loadingText } = useLoading();
    
    return (
        <>
            {/* Page Loader */}
            {isLoading && <PageLoader text={loadingText} />}
            
            <div className="main-layout h-100">
                <Sidebar/>
                {/* Mobile overlay */}
                {isSidebarOpen && (
                    <div 
                        className="sidebar-overlay d-lg-none"
                        onClick={closeSidebar}
                    />
                )}
                <section className={`main-body-sec ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
                    <Header />
                    <NavigationWrapper />
                </section>
            </div>
        </>
    );
};

const MainLayout = () => {
    return (
        <LoadingProvider>
            <PageLoadingProvider>
                <ContentLoadingProvider>
                    <SidebarProvider>
                        <MainLayoutContent />
                    </SidebarProvider>
                </ContentLoadingProvider>
            </PageLoadingProvider>
        </LoadingProvider>
    );
};

export default MainLayout;